import React from 'react';
import { Star } from 'lucide-react';

const StarRating = ({ value = 5, onChange, size = 18, readonly = false }) => (
  <div className="flex items-center gap-0.5">
    {[1, 2, 3, 4, 5].map((n) => {
      const filled = n <= value;
      const star = (
        <Star
          size={size}
          className={filled ? 'text-[#F5C518]' : 'text-[#DDD]'}
          fill={filled ? '#F5C518' : 'none'}
          strokeWidth={1.5}
        />
      );
      if (readonly || !onChange) {
        return (
          <span key={n} aria-hidden>
            {star}
          </span>
        );
      }
      return (
        <button
          key={n}
          type="button"
          onClick={() => onChange(n)}
          className="p-0.5 hover:scale-110 transition-transform"
          aria-label={`${n} star${n > 1 ? 's' : ''}`}
        >
          {star}
        </button>
      );
    })}
  </div>
);

export const StarText = ({ rating }) => (
  <span style={{ fontSize: '14px', letterSpacing: '1px' }}>
    {[1, 2, 3, 4, 5].map((n) => (
      <span key={n} style={{ color: n <= rating ? '#F5C518' : '#DDD' }}>
        ★
      </span>
    ))}
  </span>
);

export default StarRating;
